module.exports = __webpack_public_path__ + "MERCEDES-logo.png";